import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@/modules/auth/ProtectedRoute';
import PlaceholderPage from '@/modules/common/components/PlaceholderPage';

// Lazy-loaded tab containers (same components, new routes)
const PreciosPage = React.lazy(() => import('@/modules/sales/pricing/PreciosPage'));
const ContratosPage = React.lazy(() => import('@/modules/sales/trades/ContratosPage'));
const PaquetesPage = React.lazy(() => import('@/modules/sales/packages/PaquetesPage'));

const EstimacionesPlaceholder = () => (
  <PlaceholderPage title="Estimaciones y Desviaciones" description="Forecasting de ventas, proyecciones de ingresos y análisis de desviaciones" />
);

export const comercialRoutes = [
  // Precios (2 tabs: programas, tramites)
  <Route key="/comercial/precios" path="/comercial/precios" element={
    <Navigate to="/comercial/precios/programas" replace />
  } />,
  <Route key="/comercial/precios/programas" path="/comercial/precios/programas" element={
    <ProtectedRoute requiredPermission="comercial.pricing.view"><PreciosPage /></ProtectedRoute>
  } />,
  <Route key="/comercial/precios/tramites" path="/comercial/precios/tramites" element={
    <ProtectedRoute requiredPermission="comercial.pricing.view"><PreciosPage /></ProtectedRoute>
  } />,

  // Convenios (2 tabs: lista, convenios)
  <Route key="/comercial/convenios" path="/comercial/convenios" element={
    <Navigate to="/comercial/convenios/lista" replace />
  } />,
  <Route key="/comercial/convenios/lista" path="/comercial/convenios/lista" element={
    <ProtectedRoute requiredPermission="comercial.agreements.view"><ContratosPage /></ProtectedRoute>
  } />,
  <Route key="/comercial/convenios/convenios" path="/comercial/convenios/convenios" element={
    <ProtectedRoute requiredPermission="comercial.agreements.view"><ContratosPage /></ProtectedRoute>
  } />,

  // Paquetes Comerciales (4 tabs: becas, descuentos, promociones, financiamiento)
  <Route key="/comercial/paquetes" path="/comercial/paquetes" element={
    <Navigate to="/comercial/paquetes/becas" replace />
  } />,
  <Route key="/comercial/paquetes/becas" path="/comercial/paquetes/becas" element={
    <ProtectedRoute requiredPermission="comercial.packages.view"><PaquetesPage /></ProtectedRoute>
  } />,
  <Route key="/comercial/paquetes/descuentos" path="/comercial/paquetes/descuentos" element={
    <ProtectedRoute requiredPermission="comercial.packages.view"><PaquetesPage /></ProtectedRoute>
  } />,
  <Route key="/comercial/paquetes/promociones" path="/comercial/paquetes/promociones" element={
    <ProtectedRoute requiredPermission="comercial.packages.view"><PaquetesPage /></ProtectedRoute>
  } />,
  <Route key="/comercial/paquetes/financiamiento" path="/comercial/paquetes/financiamiento" element={
    <ProtectedRoute requiredPermission="comercial.packages.view"><PaquetesPage /></ProtectedRoute>
  } />,

  // Estimaciones y Desviaciones (placeholder)
  <Route key="/comercial/estimaciones" path="/comercial/estimaciones" element={
    <ProtectedRoute requiredPermission="comercial.pricing.view"><EstimacionesPlaceholder /></ProtectedRoute>
  } />,
];
